import { useFormState } from 'react-final-form';
import type { CJEvent } from '@teetsh/app/src/types/event';
import type { CahierJournalContext } from '@teetsh/app/src/containers/CahierJournal/hooks/useAIAssistCahierJournal';
import { useClassroomNiveaux } from 'containers/App/context/ClassroomsContext/useClassroomNiveaux';
import differenceInMinutes from '@teetsh/app/src/utils/time/differenceInMinutes';
import { CJAtelier } from 'types/cj';

export function useGetAIAssistCJAtelierContextFromForm(
  atelier: CJAtelier,
): CahierJournalContext {
  const formState = useFormState<CJEvent>();
  const { values } = formState;

  const niveaux = useClassroomNiveaux(values?.classroomIds);

  return {
    bo: atelier.bo,
    title: atelier.title,
    flow: atelier.flow,
    lengthInMinutes: differenceInMinutes(values.end, values.start),
    materials: atelier.materials,
    cycle: atelier.cycle,
    tagName: values.tag?.title,
    niveaux: (niveaux || [])?.length > 0 ? niveaux.join(',') : '',
  };
}
